import { useEffect } from "react";

export const SITE = "https://thetealist.com";
export const DEFAULT_TITLE = "The Tea List — Australia's independent tea journal";

const HREFLANGS = ["en-au", "en-nz", "en", "x-default"];

export const upsertLink = (rel, attrs, href) => {
  const sel = `link[rel="${rel}"]` + Object.entries(attrs).map(([k, v]) => `[${k}="${v}"]`).join("");
  let link = document.querySelector(sel);
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", rel);
    Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
};

/**
 * Sets <link rel="canonical"> + self-referencing hreflang (en-au / en-nz /
 * x-default) and mirrors og:url. Accepts an absolute URL or a "/path" that is
 * resolved against the canonical production origin.
 */
export default function useCanonical(urlOrPath) {
  useEffect(() => {
    if (!urlOrPath) return;
    const href = urlOrPath.startsWith("http")
      ? urlOrPath
      : `${SITE}${urlOrPath.startsWith("/") ? "" : "/"}${urlOrPath}`;

    upsertLink("canonical", {}, href);
    HREFLANGS.forEach((lang) => upsertLink("alternate", { hreflang: lang }, href));

    let og = document.querySelector('meta[property="og:url"]');
    if (!og) {
      og = document.createElement("meta");
      og.setAttribute("property", "og:url");
      document.head.appendChild(og);
    }
    og.setAttribute("content", href);
  }, [urlOrPath]);
}
